"use strict";var e=require("./getRulesText.js");exports.getScreenReaderText=t=>{const r=t.filter((e=>{let{status:t}=e;return"error"===t}));return 0===r.length?null:e.getInlineText(r)};
